import React, { useEffect, useState } from "react";
import * as Yup from "yup";

import Form from "@Components/Form";
import {
  STATE_FETCH_URL,
  URLS,
  REMARKS_URL,
  NON_WORKING_DAY_WEEKEND_URL,
} from "configs/constants";
import { fetchDataFromApi } from "utils";
import eightAxios from "configs/axiosConfig";
import { useNotifyContext } from "@Components/Notify";
import { useParams, useHistory } from "react-router-dom";

const initialValues = {
  // status: "",
  day: "",
  state: [],
  type_of_attendance_absent: "",
  type_of_attendance_present: "",
  is_global: false,
};

const WeekendNonWorkingDayForm = () => {
  const history = useHistory();
  const params = useParams();
  const [presentAttendanceType, setPresentAttendanceType] = useState([]);
  const [absentAttendanceType, setAbsentAttendanceType] = useState([]);
  const setNotify = useNotifyContext();


  const [isActiveGlobal, setIsActiveGlobal] = useState(false);

  const handleIsGlobalChange = (event) => {
    setIsActiveGlobal(event.value)
  };

  useEffect(() => {
    fetchDataFromApi(
      REMARKS_URL + "?status=Present",
      setPresentAttendanceType,
      true
    );
  }, []);

  useEffect(() => {
    fetchDataFromApi(
      REMARKS_URL + "?status=Absent",
      setAbsentAttendanceType,
      true
    );
  }, []);

  const handleSubmit = (values, { setSubmitting }) => {
    if (values.id === undefined) {
      eightAxios
        .post(NON_WORKING_DAY_WEEKEND_URL, values)
        .then(() => {
          history.push(URLS.NON_WORKING_DAY_WEEKEND);
        })
        .catch((error) => {
          setNotify({
            isOpen: true,
            message: error.response.data.message,
            type: "error",
          });
          setSubmitting(false);
        });
    } else {
      eightAxios
        .patch(`${NON_WORKING_DAY_WEEKEND_URL}${params.id}/`, values)
        .then(() => {
          history.push(URLS.NON_WORKING_DAY_WEEKEND);
        })
        .catch((error) => {
          setNotify({
            isOpen: true,
            message: error.response.data.message,
            type: "error",
          });
          setSubmitting(false);
        });
    }
  };
  /* const validationSchema = Yup.object({
    state: Yup.array()
    .min(1, "No State selected")
      .required("State is required")
      .typeError("Invalid State"),
  }); */

  const validationSchema = Yup.object({
    is_global: Yup.boolean(), // Ensure is_global is part of the schema
    state: Yup.array().when("is_global", {
      is: false, // when is_global is false
      then: Yup.array()
        .min(1, "No State selected")
        .required("State is required")
        .typeError("Invalid State"),
      otherwise: Yup.array().notRequired(), // no validation when is_global is true
    }),
  });


  const formFields = [
    {
      type: "reactselect",
      name: "day",
      label: "Day",
      outerOptions: [
        { id: "Monday", name: "Monday" },
        { id: "Tuesday", name: "Tuesday" },
        { id: "Wednesday", name: "Wednesday" },
        { id: "Thursday", name: "Thursday" },
        { id: "Friday", name: "Friday" },
        { id: "Saturday", name: "Saturday" },
        { id: "Sunday", name: "Sunday" },
      ],
      required: true,
    },
    {
      type: "reactselect",
      name: "type_of_attendance_absent",
      label: "Type of Attendance (Absent)",
      required: true,
      outerOptions: absentAttendanceType,
    },
    {
      type: "reactselect",
      name: "type_of_attendance_present",
      label: "Type of Attendance (Present)",
      required: true,
      outerOptions: presentAttendanceType,
    },
    {
      type: "switch",
      name: "is_global",
      label: "Global",
      required: true,
      nolabel: "No",
      yeslabel: "Yes",
      getValue: handleIsGlobalChange,
    },
    {
      type: "reactselect",
      name: "state",
      label: "State",
       required: true,
      proxyUrl: STATE_FETCH_URL,
      paginated: true,
      isMultiSelect: true,
      requiredValidation: "is_global",
      renderKey: "is_global",
      renderValue: false,
    },
  ];

  const formButtons = ["save", "cancel"];

  return (
    <Form
      initialValues={initialValues}
      outerSubmitHandler={handleSubmit}
      submitUrl={NON_WORKING_DAY_WEEKEND_URL}
      listRoute={URLS.NON_WORKING_DAY_WEEKEND}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Weekend"
      validationSchema={validationSchema}

    />
  );
};

export default WeekendNonWorkingDayForm;
